<template lang="pug">
extends Button.pug

block contents
    span(v-if="!active") {{ $t('social.follow') }}
    span(v-else)  {{ $t('social.followed') }}

</template>

<script>
import SocialMixin from '@/components/Base/SocialMixin';

export default {
    name: 'social-follow',

    props: {
        withTooltip: {      type: Boolean, default: true }
    },

    mixins: [ SocialMixin ],

    data: function () {
        return {
            operation: 'follow'
        };
    },

    methods: {
        getTooltipText: function () {
            if (!this.isAllowed) {
                return this.$t('signup.signupRequired');
            }

            return this.item && this.item.TagLine;
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

.social.do-follow {
    height: 30px;
    min-width: 120px;
    padding: 0 1.5rem;
    font-size: 0.8rem;
    border-color: black;
    border-width: 1px;
    &.active {
        color: white;
        background-color: black;
    }
    &:hover {
        font-weight: bold;
        color: black;
        background: rgba(240, 240, 240, 0.45);
        &.active {
            color: white;
            background-color: black;
        }
    }
}
</style>
